import { render, staticRenderFns } from "./TransferInComponent.vue?vue&type=template&id=081d3084&"
import script from "./TransferInComponent.vue?vue&type=script&lang=js&"
export * from "./TransferInComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports